import { CREATE_EDUCATION, REMOVE_EDUCATION } from "./actions";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../../../utils/localStorage";

export const educations = (state=loadFromLocalStorage(CREATE_EDUCATION, []), action) =>{
    const {type, payload} = action;

    switch(type){
        case CREATE_EDUCATION:{
            const {education} = payload;
            const newEducation = {
                education,
            };
            const updatedState = state.concat(newEducation);
            saveToLocalStorage(CREATE_EDUCATION, updatedState);
            return updatedState;
        }
        case REMOVE_EDUCATION: {
            const {education} = payload;
            const updatedState = state.filter(obj => obj.education !== education);
            saveToLocalStorage(CREATE_EDUCATION, updatedState);
            return updatedState;
        }
        default: 
            return state;
    }
}